import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17 * (props.wx ?? 1)}
    height={29 * (props.hx ?? 1)}
    viewBox="0 0 17 29"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.62 1.82c1.305 0 4.699-1.96 6.66.18 1.429 1.56 1.074 5.113.153 7.833-.462 1.365-.867 2.638-.648 4.762.7 6.78.354 12.982-1.005 13.2-1.442.232-3.14-11.008-5.16-11.048-1.693.104-2.138 6.957-2.524 9.819-.308 2.288-1.263 2.332-2.104.307-1.011-2.436-2.01-7.488-1.713-12.628.064-1.112.236-2.603-.183-3.635C.97 7.836.39 3.713 1.961 2c1.96-2.14 5.354-.18 6.66-.18"
    />
  </svg>
);
export default SvgNormal;
